import React from 'react'
import { Card, Badge } from 'react-bootstrap'
import d_log from 'loglevel'

function Home() {
  const serviceUrl = import.meta.env.VITE_SERVICE_URL

  return (
    <div>
      <h1>Welcome to DSRAG</h1>
      
      <Card className="mt-4 mb-4" border="info">
        <Card.Body>
          <Card.Title>Service Configuration</Card.Title>
          <Card.Text>
            Service URL: <Badge bg="secondary">{serviceUrl}</Badge>
          </Card.Text>
        </Card.Body>
      </Card>

      <Card className="mt-4">
        <Card.Body>
          <Card.Title>Document Retrieval & AI Chat System</Card.Title>
          <Card.Text>
            DSRAG is a powerful system that combines document retrieval with AI-powered chat capabilities. 
            Upload your documents, ask questions, and get intelligent responses based on your content.
          </Card.Text>
          <Card.Text>
            Features:
          </Card.Text>
          <ul>
            <li>Document upload and processing</li>
            <li>AI-powered chat interface</li>
            <li>Secure authentication</li>
            <li>Real-time responses</li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  )
}

export default Home